/**
 * Get the Locations list from API
 * @param {object} state - The vuex state object
 * @return {object[]} A array of locations list
 */
export const getLocationsList = (state) => {
  return Array.isArray(state.locationsList) ? state.locationsList : null
};
